export default __webpack_public_path__ + "static/media/video-interaction.4003c08e.png";